<p-toast key="skillVerificationToast"></p-toast>

<div id="mySkillVerificationPanelList">
    <div class="mySkillVerificationPanelList">
        <app-panel-list [showLoader]="showLoader" [panelList]="skillVerificationPanelList" [noResultFound]="noData"
            [ifAdditionalItems]="true" [isExportButtonAvailable]="false" (selectedItems)="getSelectedItems($event)">
            <span class="additional-items">
                <p-checkbox class="show-all-checkbox" name="showAllSkills" value="all" *ngIf="isShowCheckbox===true"
                    [(ngModel)]="selectCheckbox" [binary]="true" (onChange)="checkboxSelectionChange()">
                </p-checkbox>
                <label *ngIf="enableInActiveLabel">
                    {{checkboxLabel}}
                </label>
                <i *ngIf="showInformationIconCheckbox===true" class="fa fa-info-circle ml-2 info-icon-color"
                    aria-hidden="true" pTooltip="{{ informationIconTooltip}}"></i>
            </span>
            <ng-template #templateRef let-data="dataVar">
                <div class="card">
                    <div class="card-container">
                        <div class="flex">
                            <div class="user-column overflow-ellipse">
                                <app-label labelText="User"></app-label>
                                <div class="overflow-ellipse content-wrap" pTooltip="{{data.userFullName}}">
                                    {{ data.userFullName }}
                                </div>
                            </div>
                            <div class="skill-column overflow-ellipse">
                                <app-label labelText="Skill"></app-label>
                                <div class="overflow-ellipse skill-header font-semibold"
                                    pTooltip="{{data.skillCode}} {{data.skillName}}">
                                    <a class="underline blue-color cursor-pointer"
                                        (click)="viewSkillDetails(data.skillCode)">
                                        {{data.skillCode}} {{data.skillName}}
                                    </a>
                                </div>
                            </div>
                            <div class="status-column">
                                <app-label labelText="Status"></app-label>
                                <div class="skill-status icon-alignment">
                                    <b>
                                        <i class="pi pi-circle-fill" [ngClass]="getStatusColor(data.status)"></i>
                                    </b>
                                    &nbsp;
                                    <div class="iconAlignment">
                                        {{displayStatus(data.status)}}
                                        <span *ngIf="data.date">
                                            ({{data.date | date:'dd-MMM-yyyy'}})
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="linked-training-items-column">
                                <app-label labelText="Linked Training Item(s)"></app-label>
                                <div class="linked-training-items-content"
                                    *ngIf="hasLinkedTrainingItems(data); else noLinkedItems">
                                    <div class="content-wrap"
                                        [class.full-text]="isPanelExpanded(data)"
                                        *ngFor="let item of getVisibleLinkedTrainingItems(data)"
                                        pTooltip="{{ getLinkedTrainingItemText(item) }}"
                                        [tooltipDisabled]="isPanelExpanded(data)">
                                        {{ getLinkedTrainingItemText(item) }}
                                    </div>
                                    <div class="content-wrap more-items"
                                        *ngIf="showMoreLinkedTrainingItemsIndicator(data)">...
                                    </div>
                                </div>
                                <ng-template #noLinkedItems>
                                    <div class="content-wrap">-</div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template #templateRef let-data="dataVar">
                <span class="expanded-content-placeholder"></span>
            </ng-template>
        </app-panel-list>
        <app-spinner *ngIf="showLoader"></app-spinner>
    </div>

    <div class="btnClass" *ngIf="skillVerificationPanelList?.lists?.length>0">
        <p-button appPreventDoubleClick label="Verify" id="verifyButton" class="verify-button"
            icon="fa-solid fa-circle-check" iconPos="left" [disabled]="selectedPanels?.length === 0"
            (debounceClick)="verifySkills()"></p-button>

        <p-button appPreventDoubleClick styleClass="p-button-outlined" label="Deny" id="denyButton"
            class="deny-button" icon="fa fa-xmark" iconPos="left" [disabled]="selectedPanels?.length !== 1"
            (debounceClick)="denySkills()"></p-button>
    </div>

    <app-removal-reason-dialog
        [display]="denyReasonDialogVisible"
        [skillName]="selectedSkillDisplayName"
        (onConfirm)="onDenyReasonConfirm($event)"
        (onCancel)="onDenyReasonCancel()">
    </app-removal-reason-dialog>

    <app-revocation-dialog
    [display]="revocationDialogVisible"
    [skillCode]="selectedSkillCode"
    [skillName]="selectedSkillDisplayName"
    (onConfirm)="onRevocationConfirm($event)"
    (onCancel)="onRevocationCancel()">
  </app-revocation-dialog>
</div>  